import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getPagingRealmController from './getPagingRealmController.js'
import _module from 'module.js'
import _ from 'lodash'

let getPagingRealmComponent = _.cloneDeep(getJrnDefaultComponent)
getPagingRealmComponent.controller = getPagingRealmController

_module.component('getPagingRealm', getPagingRealmComponent)
